<template>
    <div>
      <nav class="navbar navbar-expand-md navbar-dark bg-primary sticky-top">
            <div class="container-fluid">
                <a class="navbar-brand" href="/">
                    <img
                        src="img/canon.svg"
                        alt
                        class="img-fluid"
                        style="max-width:140px;"
                        title="Canon"
                    />
                    Canon do Brasil
                </a>
            </div>
        </nav>
        <main>
            <div class="container">

                <h2>Verifique aqui o status de seus reparos.</h2>
                <h5>Se precisar de mais informações, por favor entre em contato com a assistência técnica.</h5>

                  <div class="accordion" role="tablist">
                    
                    <b-card no-body class="mb-1" v-for="repair in repairs" :key="repair">
                      <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle="'accordion-' + repair.id" variant="info" class="bg-primary" style="border: none;"><h4>Reparo {{ repair.repair_id}}</h4> <h5>{{ $t('status.repairstr.s_' + repair.last_status.status_name.toLowerCase().replace(/\s|\/|\-|\(|\)/g, '')) }}</h5></b-button>
                      </b-card-header>
                      <b-collapse :id="'accordion-' + repair.id" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          
                          <div class="row">
                            <div class="col-md-6">
                              <div class="card">
                                <div class="card-body">
                                    <h6>Tipo de Reparo Técnico:</h6>
                                    <div v-if="['In Warranty'].includes(repair.warranty)">Em Garantia</div>
                                    <div v-else>Fora de Garantia</div>
                                </div>
                              </div>                             
                            </div>
                            <div class="col-md-6">
                               <div class="card">
                                <div class="card-body">
                                  <h6>Dados da Assistência Técnica</h6>
                                  Nome: {{ repair.asf.name }} - Telefone: {{ getAsfPhone(repair.asf.id) }}
                                </div>
                              </div>   
                            </div>
                          </div>

                          <div class="row my-4" v-if="['In Warranty', 'Partial Warranty'].includes(repair.warranty)">
                              <ul class="progressbar">
                                  <li v-for="(stat, index) in status(repair.warranty)" :class="setProgress(repair, stat)" >                          
                                      {{$t('status.repair[' + (stat.id-1) + ']')}}
                                      <br />
                                      <small class="text-muted mt-2" v-html="getStatusUserAndDate(repair, index)"></small>
                                  </li>
                              </ul>
                              <br />
                          </div>

                        </b-card-body>
                      </b-collapse>
                    </b-card>

                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    if (this.$store.state.client_repairs === undefined) {
      this.$router.push("/");
    }

    return {   
      repairs: this.$store.state.client_repairs[0],
      phones: this.$store.state.client_repairs[1]
    };
  },
  computed: {
  },
  methods: {
    status(warranty) {
      let response = [
        {'status': "Waiting Canon Authorization", 'id': 1},
        {'status': "Waiting ASF Inspection", 'id': 2},
        {'status': "Waiting Parts", 'id': 3},
        {'status': "On Repair", 'id': 4},
        {'status': "Waiting Customer Pick-up/Waiting Expedition", 'id': 5},
        {'status': "Collected by Customer/Delivered to customer", 'id': 6}
      ];
      
      return response;
    },
    getAsfPhone(repair_id) {
      let phone = [];

      this.phones.forEach((item) => {
        if ( item.model_id == repair_id) {
          phone = item;
        }
      });
  
      return phone.phone;
    },
    setProgress(repair, item) {
      if (parseInt(repair.last_status.status_order) > 60) return "done";
      if (item.status == repair.last_status.status_name) return "active";
      if ( (item.id*10) < parseInt(repair.last_status.status_order)) return "done";
    },
    getStatusUserAndDate(repair, index) {

      let current = repair.status[index];

      if (current != undefined) {
        return (
          "<div class='my-1'>" +
          this.$moment(current.created_at).format("DD.MM.YYYY HH:mm:ss") +
          "</div>"
        );
      }
    }
  }
};
</script>